export default __webpack_public_path__ + "static/media/records_dataroom_icon.105959e5.png";